import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "src/environments/environment";
import { SmsService } from "src/app/modules/shared/services/sms.service";
import { catchError, switchMap, tap } from "rxjs/operators";
import { AuthService } from "src/app/modules/auth";


@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
    constructor(
        private _Sms: SmsService,
        private authService: AuthService
    ) { }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        let auth = this.authService.getAuthFromLocalStorage();
        const isLoggedIn = localStorage.getItem('token');
        // const isSms = request.url.startsWith(environment.sma.apiUrl);
        const isSms = request.url.includes('api-sms') || request.url.includes(environment.sallaUrl) 
        || request.url.includes(environment.commission.api);
        const smsAuthData = localStorage.getItem('smsAuthData');
        if (!auth?.accessToken || !smsAuthData || !isSms ) return next.handle(request);
        // this._Sms.getSmsAuthenticationData().pipe(
        //     tap(res => {
        //         debugger
        //         if(res){
        //             request = request.clone({
        //                 setHeaders: {
        //                     Authorization: `Basic ${res}`,
        //                 },
        //             });
        //         }
        //     }),
        //     switchMap((res) => {
        //         return next.handle(request);
        //     }),
        //     catchError(err => {
        //         return next.handle(request);
        //     })
        // );
        if (!request.headers.has('Authorization')) {
            request = request.clone({
                headers: request.headers.set('Authorization', `Basic ${smsAuthData}`)
            })
        }        
      
        return next.handle(request);

    }

    // MDQxZjkzZmQtMTg1Yy00MjNhLTkxZDktZTczMjY2MDBjZDVkOjFkOTA1ODhmLTlhZTMtNGFiMy1iYzM1LTRjNTFhMGJkOGE3YQ==
}
